<template>
<div>
 <Header @getLanguageMap='getLanguageMap'></Header>
<!-- <div class="crumbs">
  <div class="container">
    <p class="title">{{languageMap[shopObj.typeName]}}</p>
    <div class="childs"> <a href="/#/">{{languageMap['主页']}}</a> &gt; <a href="/#/jishu/">{{languageMap['服务支持']}}</a> &gt; 
       <span v-if="shopObj.shopTypeIds==18"><a href="/#/jishu/chanpin/">{{languageMap['说明文档']}}</a> &gt;</span>
       <span v-else-if="shopObj.shopTypeIds==19"><a href="/#/jishu/xia/">{{languageMap['软件下载']}}</a> &gt;</span>
       <span v-else-if="shopObj.shopTypeIds==21"><a href="/#/jishu/zhinan/">{{languageMap['操作指南']}}</a> &gt;</span>
       <span v-else-if="shopObj.shopTypeIds != 15"><a :href="'/#/jishu/wenti?id='+shopObj.shopTypeIds">{{languageMap[shopObj.typeName]}}</a> &gt;</span> 
     </div>
  </div>
</div> -->
<NavigationBar></NavigationBar>
<div class="main">
  <div class="container">
    <div class="mainHead">
      <p class="title">{{languageMap[shopObj.name]}}</p>
      <p class="time">{{shopObj.updateTime}}</p>
    </div>
    <!-- mainContent -->
 <div class="mainContent" v-if="shopObj.shopTypeIds==18 || shopObj.shopTypeIds==19 || shopObj.shopTypeIds==21">
<div style="transition-property: all; -webkit-transition-property: all; color: rgb(102, 102, 102); font-size: 14px; line-height: 24px; padding: 1px 0px; font-family: 'Microsoft YaHei', 'Helvetica Neue', Tahoma, Arial, 微软雅黑, 宋体, 黑体;"><br>
  <p></p><li>
    <a href="javascript:void(0)" @click="downloadFile(shopObj.id)" >{{languageMap['本地下载']}}</a>
    </li><p></p>
								   <p></p><br><br> <p>{{languageMap['温馨提示：点击本地下载即可查看']}}</p> <p></p>
								   
								   </div>
 </div>

<div class="mainContent" v-else>
<div v-html="languageMap['fileName']=='chinese.txt' ? shopObj.detailContent : shopObj.detailContentEnglish" style="transition-property: all; -webkit-transition-property: all; color: rgb(102, 102, 102); font-size: 14px; line-height: 24px; padding: 1px 0px; font-family: 'Microsoft YaHei', 'Helvetica Neue', Tahoma, Arial, 微软雅黑, 宋体, 黑体;">
</div>
 </div>

    
    <!-- mainContent over --> 
    <!-- mainFoot -->
 
    <!-- mainFoot over --> 
    <!-- about -->
   
    <!-- about over --> 
  </div>
</div>
 <Footer></Footer>
</div>
</template>

<style scoped>
/* newsinfo.css */
.mainHead .title {
	line-height:40px;
	color:#333333;
	font-size:28px;
}
.mainHead .time {
	font-size:14px;
	color:#999999;
	line-height:24px;
	padding-top:7;
}
.mainContent img {
	max-width: 100% !important;
	height: auto !important;
}
.mainContent input[type='image'] {
	max-width: 100%;
	height: auto !important;
}
.mainContent p {
	color:#666;
	font-size:14px;
	line-height:24px;
	padding:1px 0;
}
.mainContent div {
	color:#666;
	font-size:14px;
	line-height:24px;
	padding:1px 0;
}
.mainContent span {
	color:#666;
	font-size:14px;
	line-height:24px;
	padding:1px 0;
}
.mainFoot {
	position:relative;
	text-align:center;
	height:78px;
	border-top:1px solid #bebebe;
	border-bottom:1px solid #bebebe;
	margin:60px 0;
}
.mainFoot .child {
	display:inline-block;
*display:inline;
*zoom:1;
	position:relative;
	width:193px;
	height:100%;
	border-left:1px solid #ddd;
}
.mainFoot a:nth-child(1) .child {
	border-left:0;
}
.mainFoot .child .childIcon, .mainFoot .child .childInfo {
	display:inline-block;
*display:inline;
*zoom:1;
	vertical-align:middle;
}
.mainFoot .child .childIcon {
	margin-top:20px;
	position:relative;
	background:#666;
	width:38px;
	height:38px;
	text-align:center;
	line-height:38px;
	border-radius:38px;
	-moz-border-radius:38px;
	-ms-border-radius:38px;
	-o-border-radius:38px;
	-webkit-border-radius:38px;
}
.mainFoot .child .childIcon img {
	vertical-align:middle;
}
.mainFoot .child .childIcon img {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.mainFoot .child:hover .childIcon img {
	transform:rotate(360deg);
	-moz-transform:rotate(360deg);
	-ms-transform:rotate(360deg);
	-o-transform:rotate(360deg);
	-webkit-transform:rotate(360deg);
}
.mainFoot .child .childInfo {
	padding-left:12px;
	text-align:left;
	margin-top: 18px;
}
.mainFoot .child .childInfo p {
	color:#666;
	font-size:14px;
}
.main .about {
	position:relative;
	padding:0px;
}
.main .about:after {
	content: "020";
	display: block;
	height: 0;
	clear: both;
	visibility:hidden;
}
.main .about .aboutTitle {
	position:relative;
	height:24px;
	padding-bottom:40px;
}
.main .about .aboutTitle span {
	position:relative;
	z-index:1;
	line-height:24px;
	font-size:18px;
	color:#333333;
	padding-right:20px;
	background:#fff;
}
.main .about .aboutTitle .sub {
	position:absolute;
	height:6px;
	background:#e8e8e8;
	top:10px;
	left:0px;
	width:100%;
}
.main .about .child {
	position:relative;
	float:left;
	width:19%;
	margin-right:1%;
}
.main .about .child .childImg {
	width:100%;
	height:auto;
}
.main .about .child .childImg {
	transition-duration: .5s;
	-ms-transition-duration: .5s;
	-moz-transition-duration: .5s;
	-webkit-transition-duration: .5s;
}
.main .about .child .childImg:hover {
	-webkit-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-moz-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-ms-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
	-o-box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.2);
}
.main .about .child .childImg img {
	width:100%;
	height:auto;
	vertical-align:middle;
}
.main .about .child .childTitle {
	color:#666;
	font-size:16px;
	line-height:24px;
	text-align:center;
}
.main .about .child .childTitle p {
	padding:26px 0;
}
.bdsharebuttonbox {
	position:absolute;
	top:0;
	left:0px;
	width: 100%;
	height: 100%;
	z-index: 1;
}
.bdsharebuttonbox a {
	display:none;
}
.bdsharebuttonbox .bds_weixin {
	width: 100%;
	height: 100%;
	display:block;
	opacity:0 !important;
	filter: alpha(opacity=0) !important;
}
@media (max-width: 639px) {
.mainHead .title {
	line-height:26px;
	font-size:20px;
}
.mainHead .time {
	font-size:12px;
	line-height:20px;
	padding-top:4;
}
.mainContent p {
	font-size:12px;
	line-height:20px;
	padding:6px 0;
}
.mainContent div {
	font-size:12px;
	line-height:20px;
	padding:6px 0;
}
.mainContent span {
	font-size:12px;
	line-height:20px;
	padding:6px 0;
}
.main .mainFoot {
	height:60px;
	margin:20px 0 0 0;
}
.main .mainFoot .child {
	width:22%;
}
.main .mainFoot .child .childIcon {
	margin-top:10px;
	width:38px;
	height:38px;
	line-height:38px;
	border-radius:38px;
	-moz-border-radius:38px;
	-ms-border-radius:38px;
	-o-border-radius:38px;
	-webkit-border-radius:38px;
}
.main .mainFoot .child .childInfo {
	display:none;
}
.main .about {
	display:none;
}
}
@media (min-width: 640px) and (max-width:1023px ) {
.mainHead .title {
	line-height:40px;
	font-size:28px;
}
.mainHead .time {
	font-size:14px;
	line-height:24px;
	padding-top:7;
}
.mainContent p {
	font-size:14px;
	line-height:24px;
	padding:8px 0;
}
.mainContent div {
	font-size:14px;
	line-height:24px;
	padding:8px 0;
}
.mainContent span {
	font-size:14px;
	line-height:24px;
	padding:8px 0;
}
.main .mainFoot {
	height:78px;
	margin:40px 0;
}
.main .mainFoot .child {
	width:24%;
}
.main .mainFoot .child .childIcon {
	margin-top:20px;
	width:38px;
	height:38px;
	line-height:38px;
	border-radius:38px;
	-moz-border-radius:38px;
	-ms-border-radius:38px;
	-o-border-radius:38px;
	-webkit-border-radius:38px;
}
.main .mainFoot .child .childInfo {
	padding-left:12px;
	margin-top: 18px;
}
.main .mainFoot .child .childInfo p {
	font-size:14px;
}
.main .about {
	padding:0px;
}
.main .about .aboutTitle {
	height:24px;
	padding-bottom:20px;
}
.main .about .aboutTitle span {
	line-height:24px;
	font-size:18px;
	padding-right:20px;
}
.main .about .aboutTitle .sub {
	height:6px;
	top:10px;
}
.main .about .child {
	width:19%;
	margin-right:1%;
}
.main .about .child .childTitle {
	font-size:16px;
	line-height:24px;
}
.main .about .child .childTitle p {
	padding:14px 0;
}
}
@media (min-width: 1024px) and (max-width:1199px ) {
.container {
	width:1000px
}
}
@media (min-width: 1200px) and (max-width:1439px ) {
.container {
	width:1000px
}
}
@media (min-width: 1440px) and (max-width:1920px ) {
.container {
	width:1000px
}
}

</style>

<script>
import store from "./../../../../store";
import config from "./../../../../config";
import Header from "@/components/front/Header.vue";
import Footer from "@/components/front/Footer.vue";
import NavigationBar from "@/components/front/NavigationBar.vue";
export default {
  data() {
    return {
      id:null,
      shopObj:{},
      languageMap:{}
    };
  },
  mounted() {


      this.init();
      this.id=this.$route.query.id;
	    this.queryByParam(this.id);
  },
  beforeDestroy(){

  },
  methods: {
    queryByParam(id){
      this.id=id;
     let url =  config.url + "FrontController/queryByParam.action";
      let param = {id:id};
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
			document.documentElement.scrollTop=0;
			if(data.data){
              this.shopObj=data.data[0];
//  if(this.shopObj.detailContent){
//   this.shopObj.detailContent=this.languageMap[this.shopObj.detailContent].split("n\\").join('\r\n');
// }

			}else{
			  this.shopObj={};
			}
        }
      }) .catch(err => {
        console.log(err);
      });
   },
   downloadFile(id){
     location.href=config.url + "FrontController/download.action?id="+id;
   },
    init(){
		/*news.js*/
		var newsIndex=0;
$(function(){
	$(".mainContent .child").each(function(index, element) {
        newsChildAn(".mainContent .child:eq("+index+")");
    });
});

function newsChildAn(e){
	var dtime=newsIndex*0.2;
	anClasAdd(e,"newsChild",".6s",dtime+"s","ease-in-out","both");
	newsIndex++;
}

/*lightbox.js*/
/**
 * Lightbox v2.7.1
 * by Lokesh Dhakar - http://lokeshdhakar.com/projects/lightbox2/
 *
 * @license http://creativecommons.org/licenses/by/2.5/
 * - Free for use in both personal and commercial projects
 * - Attribution requires leaving author name, author link, and the license info intact
 */

(function() {
  // Use local alias
  var $ = jQuery;

  var LightboxOptions = (function() {
    function LightboxOptions() {
      this.fadeDuration                = 500;
      this.fitImagesInViewport         = true;
      this.resizeDuration              = 700;
      this.positionFromTop             = 50;
      this.showImageNumberLabel        = true;
      this.alwaysShowNavOnTouchDevices = false;
      this.wrapAround                  = false;
    }
    
    // Change to localize to non-english language
    LightboxOptions.prototype.albumLabel = function(curImageNum, albumSize) {
      return "Image " + curImageNum + " of " + albumSize;
    };

    return LightboxOptions;
  })();


  var Lightbox = (function() {
    function Lightbox(options) {
      this.options           = options;
      this.album             = [];
      this.currentImageIndex = void 0;
      this.init();
    }

    Lightbox.prototype.init = function() {
      this.enable();
      this.build();
    };

    // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
    // that contain 'lightbox'. When these are clicked, start lightbox.
    Lightbox.prototype.enable = function() {
      var self = this;
      $('body').on('click', 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function(event) {
        self.start($(event.currentTarget));
        return false;
      });
    };

    // Build html for the lightbox and the overlay.
    // Attach event handlers to the new DOM elements. click click click
    Lightbox.prototype.build = function() {
      var self = this;
      $("<div id='lightboxOverlay' class='lightboxOverlay' style='display: none;'></div><div id='lightbox' class='lightbox' style='display: none;'><div class='lb-outerContainer'><div class='lb-container'><img class='lb-image' src='' /><div class='lb-nav'><a class='lb-prev' href='' ></a><a class='lb-next' href='' ></a></div><div class='lb-loader'><a class='lb-cancel'></a></div></div></div><div class='lb-dataContainer'><div class='lb-data'><div class='lb-details'><span class='lb-caption'></span><span class='lb-number'></span></div><div class='lb-closeContainer'><a class='lb-close'></a></div></div></div></div>").appendTo($('body'));
      
      // Cache jQuery objects
      this.$lightbox       = $('#lightbox');
      this.$overlay        = $('#lightboxOverlay');
      this.$outerContainer = this.$lightbox.find('.lb-outerContainer');
      this.$container      = this.$lightbox.find('.lb-container');

      // Store css values for future lookup
      this.containerTopPadding = parseInt(this.$container.css('padding-top'), 10);
      this.containerRightPadding = parseInt(this.$container.css('padding-right'), 10);
      this.containerBottomPadding = parseInt(this.$container.css('padding-bottom'), 10);
      this.containerLeftPadding = parseInt(this.$container.css('padding-left'), 10);
      
      // Attach event handlers to the newly minted DOM elements
      this.$overlay.hide().on('click', function() {
        self.end();
        return false;
      });

      this.$lightbox.hide().on('click', function(event) {
        if ($(event.target).attr('id') === 'lightbox') {
          self.end();
        }
        return false;
      });

      this.$outerContainer.on('click', function(event) {
        if ($(event.target).attr('id') === 'lightbox') {
          self.end();
        }
        return false;
      });

      this.$lightbox.find('.lb-prev').on('click', function() {
        if (self.currentImageIndex === 0) {
          self.changeImage(self.album.length - 1);
        } else {
          self.changeImage(self.currentImageIndex - 1);
        }
        return false;
      });

      this.$lightbox.find('.lb-next').on('click', function() {
        if (self.currentImageIndex === self.album.length - 1) {
          self.changeImage(0);
        } else {
          self.changeImage(self.currentImageIndex + 1);
        }
        return false;
      });

      this.$lightbox.find('.lb-loader, .lb-close').on('click', function() {
        self.end();
        return false;
      });
    };

    // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
    Lightbox.prototype.start = function($link) {
      var self    = this;
      var $window = $(window);

      $window.on('resize', $.proxy(this.sizeOverlay, this));

      $('select, object, embed').css({
        visibility: "hidden"
      });

      this.sizeOverlay();

      this.album = [];
      var imageNumber = 0;

      function addToAlbum($link) {
        self.album.push({
          link: $link.attr('href'),
          title: $link.attr('data-title') || $link.attr('title')
        });
      }

      // Support both data-lightbox attribute and rel attribute implementations
      var dataLightboxValue = $link.attr('data-lightbox');
      var $links;

      if (dataLightboxValue) {
        $links = $($link.prop("tagName") + '[data-lightbox="' + dataLightboxValue + '"]');
        for (var i = 0; i < $links.length; i = ++i) {
          addToAlbum($($links[i]));
          if ($links[i] === $link[0]) {
            imageNumber = i;
          }
        }
      } else {
        if ($link.attr('rel') === 'lightbox') {
          // If image is not part of a set
          addToAlbum($link);
        } else {
          // If image is part of a set
          $links = $($link.prop("tagName") + '[rel="' + $link.attr('rel') + '"]');
          for (var j = 0; j < $links.length; j = ++j) {
            addToAlbum($($links[j]));
            if ($links[j] === $link[0]) {
              imageNumber = j;
            }
          }
        }
      }
      
      // Position Lightbox
      var top  = $window.scrollTop() + this.options.positionFromTop;
      var left = $window.scrollLeft();
      this.$lightbox.css({
        top: top + 'px',
        left: left + 'px'
      }).fadeIn(this.options.fadeDuration);

      this.changeImage(imageNumber);
    };

    // Hide most UI elements in preparation for the animated resizing of the lightbox.
    Lightbox.prototype.changeImage = function(imageNumber) {
      var self = this;

      this.disableKeyboardNav();
      var $image = this.$lightbox.find('.lb-image');

      this.$overlay.fadeIn(this.options.fadeDuration);

      $('.lb-loader').fadeIn('slow');
      this.$lightbox.find('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption').hide();

      this.$outerContainer.addClass('animating');

      // When image to show is preloaded, we send the width and height to sizeContainer()
      var preloader = new Image();
      preloader.onload = function() {
        var $preloader, imageHeight, imageWidth, maxImageHeight, maxImageWidth, windowHeight, windowWidth;
        $image.attr('src', self.album[imageNumber].link);

        $preloader = $(preloader);

        $image.width(preloader.width);
        $image.height(preloader.height);
        
        if (self.options.fitImagesInViewport) {
          // Fit image inside the viewport.
          // Take into account the border around the image and an additional 10px gutter on each side.

          windowWidth    = $(window).width();
          windowHeight   = $(window).height();
          maxImageWidth  = windowWidth - self.containerLeftPadding - self.containerRightPadding - 20;
          maxImageHeight = windowHeight - self.containerTopPadding - self.containerBottomPadding - 120;

          // Is there a fitting issue?
          if ((preloader.width > maxImageWidth) || (preloader.height > maxImageHeight)) {
            if ((preloader.width / maxImageWidth) > (preloader.height / maxImageHeight)) {
              imageWidth  = maxImageWidth;
              imageHeight = parseInt(preloader.height / (preloader.width / imageWidth), 10);
              $image.width(imageWidth);
              $image.height(imageHeight);
            } else {
              imageHeight = maxImageHeight;
              imageWidth = parseInt(preloader.width / (preloader.height / imageHeight), 10);
              $image.width(imageWidth);
              $image.height(imageHeight);
            }
          }
        }
        self.sizeContainer($image.width(), $image.height());
      };

      preloader.src          = this.album[imageNumber].link;
      this.currentImageIndex = imageNumber;
    };

    // Stretch overlay to fit the viewport
    Lightbox.prototype.sizeOverlay = function() {
      this.$overlay
        .width($(window).width())
        .height($(document).height());
    };

    // Animate the size of the lightbox to fit the image we are showing
    Lightbox.prototype.sizeContainer = function(imageWidth, imageHeight) {
      var self = this;
      
      var oldWidth  = this.$outerContainer.outerWidth();
      var oldHeight = this.$outerContainer.outerHeight();
      var newWidth  = imageWidth + this.containerLeftPadding + this.containerRightPadding;
      var newHeight = imageHeight + this.containerTopPadding + this.containerBottomPadding;
      
      function postResize() {
        self.$lightbox.find('.lb-dataContainer').width(newWidth);
        self.$lightbox.find('.lb-prevLink').height(newHeight);
        self.$lightbox.find('.lb-nextLink').height(newHeight);
        self.showImage();
      }

      if (oldWidth !== newWidth || oldHeight !== newHeight) {
        this.$outerContainer.animate({
          width: newWidth,
          height: newHeight
        }, this.options.resizeDuration, 'swing', function() {
          postResize();
        });
      } else {
        postResize();
      }
    };

    // Display the image and it's details and begin preload neighboring images.
    Lightbox.prototype.showImage = function() {
      this.$lightbox.find('.lb-loader').hide();
      this.$lightbox.find('.lb-image').fadeIn('slow');
    
      this.updateNav();
      this.updateDetails();
      this.preloadNeighboringImages();
      this.enableKeyboardNav();
    };

    // Display previous and next navigation if appropriate.
    Lightbox.prototype.updateNav = function() {
      // Check to see if the browser supports touch events. If so, we take the conservative approach
      // and assume that mouse hover events are not supported and always show prev/next navigation
      // arrows in image sets.
      var alwaysShowNav = false;
      try {
        document.createEvent("TouchEvent");
        alwaysShowNav = (this.options.alwaysShowNavOnTouchDevices)? true: false;
      } catch (e) {}

      this.$lightbox.find('.lb-nav').show();

      if (this.album.length > 1) {
        if (this.options.wrapAround) {
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1');
          }
          this.$lightbox.find('.lb-prev, .lb-next').show();
        } else {
          if (this.currentImageIndex > 0) {
            this.$lightbox.find('.lb-prev').show();
            if (alwaysShowNav) {
              this.$lightbox.find('.lb-prev').css('opacity', '1');
            }
          }
          if (this.currentImageIndex < this.album.length - 1) {
            this.$lightbox.find('.lb-next').show();
            if (alwaysShowNav) {
              this.$lightbox.find('.lb-next').css('opacity', '1');
            }
          }
        }
      }
    };

    // Display caption, image number, and closing button.
    Lightbox.prototype.updateDetails = function() {
      var self = this;

      // Enable anchor clicks in the injected caption html.
      // Thanks Nate Wright for the fix. @https://github.com/NateWr
      if (typeof this.album[this.currentImageIndex].title !== 'undefined' && this.album[this.currentImageIndex].title !== "") {
        this.$lightbox.find('.lb-caption')
          .html(this.album[this.currentImageIndex].title)
          .fadeIn('fast')
          .find('a').on('click', function(event){
            location.href = $(this).attr('href');
          });
      }
    
      if (this.album.length > 1 && this.options.showImageNumberLabel) {
        this.$lightbox.find('.lb-number').text(this.options.albumLabel(this.currentImageIndex + 1, this.album.length)).fadeIn('fast');
      } else {
        this.$lightbox.find('.lb-number').hide();
      }
    
      this.$outerContainer.removeClass('animating');
    
      this.$lightbox.find('.lb-dataContainer').fadeIn(this.options.resizeDuration, function() {
        return self.sizeOverlay();
      });
    };

    // Preload previous and next images in set.
    Lightbox.prototype.preloadNeighboringImages = function() {
      if (this.album.length > this.currentImageIndex + 1) {
        var preloadNext = new Image();
        preloadNext.src = this.album[this.currentImageIndex + 1].link;
      }
      if (this.currentImageIndex > 0) {
        var preloadPrev = new Image();
        preloadPrev.src = this.album[this.currentImageIndex - 1].link;
      }
    };

    Lightbox.prototype.enableKeyboardNav = function() {
      $(document).on('keyup.keyboard', $.proxy(this.keyboardAction, this));
    };

    Lightbox.prototype.disableKeyboardNav = function() {
      $(document).off('.keyboard');
    };

    Lightbox.prototype.keyboardAction = function(event) {
      var KEYCODE_ESC        = 27;
      var KEYCODE_LEFTARROW  = 37;
      var KEYCODE_RIGHTARROW = 39;

      var keycode = event.keyCode;
      var key     = String.fromCharCode(keycode).toLowerCase();
      if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
        this.end();
      } else if (key === 'p' || keycode === KEYCODE_LEFTARROW) {
        if (this.currentImageIndex !== 0) {
          this.changeImage(this.currentImageIndex - 1);
        } else if (this.options.wrapAround && this.album.length > 1) {
          this.changeImage(this.album.length - 1);
        }
      } else if (key === 'n' || keycode === KEYCODE_RIGHTARROW) {
        if (this.currentImageIndex !== this.album.length - 1) {
          this.changeImage(this.currentImageIndex + 1);
        } else if (this.options.wrapAround && this.album.length > 1) {
          this.changeImage(0);
        }
      }
    };

    // Closing time. :-(
    Lightbox.prototype.end = function() {
      this.disableKeyboardNav();
      $(window).off("resize", this.sizeOverlay);
      this.$lightbox.fadeOut(this.options.fadeDuration);
      this.$overlay.fadeOut(this.options.fadeDuration);
      $('select, object, embed').css({
        visibility: "visible"
      });
    };

    return Lightbox;

  })();

  $(function() {
    var options  = new LightboxOptions();
    var lightbox = new Lightbox(options);
  });

}).call(this);

  },
   getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 },
    getLanguageMap(e){
      this.languageMap=e;
      this.$emit('getLanguageMap',e)
    }
  },
  components: {
    Header,
    Footer,
    NavigationBar
  }
};
</script>
